import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "TextMining"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M11.2501 19.1047H11.2509L10.1161 20.0865L0.537109 9.03375L5.62511 2.25H16.8751L21.9631 9.03375L18.7419 12.7515L17.6071 11.769L20.0371 8.96625L16.1251 3.75H6.37511L2.46311 8.96625L11.2501 19.1047ZM19.5002 21H13.5002V22.5H19.5002V21ZM13.5002 18H22.5002V19.5H13.5002V18ZM22.5002 15H13.5002V16.5H22.5002V15Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/TextMining.vue"]]);
